/**
 * Düz <v-table> tablolarında (v-data-table hariç; onlar ResponsiveDataTable ile
 * çalışır) yatay kaydırmayı engeller:
 *  - Hücrelere sütun başlığını data-label olarak yazar,
 *  - Tablo genişliğe sığmıyorsa (veya telefonda) `data-stacked="true"` verir;
 *    global.css bu durumda her satırı bir karta çevirir.
 * (Vue'nun yönettiği class'ı bozmamak için class değil data-attribute kullanılır.)
 */
const MIN_COLUMNS = 3; // key/value gibi 2 sütunlu tablolar zaten sığıyor
const PHONE = 600;
const MIN_COLUMN_WIDTH = 130;

function label(table) {
  const headRows = table.tHead ? table.tHead.rows : [];
  if (headRows.length !== 1) return false;
  const headers = Array.from(headRows[0].cells);
  if (headers.length < MIN_COLUMNS || headers.some((h) => h.colSpan > 1)) {
    return false;
  }
  const titles = headers.map((h) => h.textContent.trim());
  Array.from(table.tBodies).forEach((body) => {
    Array.from(body.rows).forEach((row) => {
      // colspan'lı (örn. "kayıt yok") satırlara dokunma
      if (Array.from(row.cells).some((c) => c.colSpan > 1)) return;
      Array.from(row.cells).forEach((cell, i) => {
        if (titles[i] !== undefined && cell.getAttribute("data-label") !== titles[i]) {
          cell.setAttribute("data-label", titles[i]);
        }
      });
    });
  });
  return true;
}

function process() {
  document.querySelectorAll(".v-table:not(.v-data-table)").forEach((root) => {
    const wrapper = root.querySelector(":scope > .v-table__wrapper");
    const table = wrapper && wrapper.querySelector(":scope > table");
    if (!table) return;
    if (!label(table)) {
      root.removeAttribute("data-stacked");
      return;
    }
    // Doğal (kartsız) genişlikte taşıyor mu? Eş zamanlı ölçüldüğü için titreme olmaz.
    root.removeAttribute("data-stacked");
    const overflow = wrapper.scrollWidth > wrapper.clientWidth + 1;
    // Çok sütunlu tablo dar bir kartta kalıyorsa (sütun başına < 130px) kelimeler ortadan
    // bölünmesin diye etiket/değer listesine çevir.
    const columns = table.tHead.rows[0].cells.length;
    const cramped = columns >= 4 && wrapper.clientWidth / columns < MIN_COLUMN_WIDTH;
    if (overflow || cramped || window.innerWidth < PHONE) {
      root.setAttribute("data-stacked", "true");
    }
  });
}

export default {
  install() {
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        process();
      });
    };
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
    window.addEventListener("resize", schedule);
    schedule();
  },
};
